export enum NPaymentMethods {
  CreditCard = 0,
  BankTransfer = 1,
  Cash=2
}
